import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"

const BordDeleteDialogComponent = ({ deleteDialog, handleCloseDeleteDialog, deleteLoading, handleConfirmDelete, loading }: any) => {
    return (
        <Dialog
            open={deleteDialog}
            onClose={handleCloseDeleteDialog}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                Delete Certificate Manager
            </DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} mt={1}>
                    <Typography variant="body1">
                        Are you sure you want to delete this certificate manager?
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDeleteDialog} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirmDelete}
                    variant="contained"
                    disabled={deleteLoading}
                    sx={{ bgcolor: '#5BC0BE', '&:hover': { bgcolor: '#49a9a7' } }}
                >
                    {deleteLoading ? 'Deleting...' : 'Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default BordDeleteDialogComponent
